import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { AnswersStore } from 'src/app/store/answers-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
// import { DragDirective } from '../../../../drag.directive';
import { map } from 'rxjs';
import { DragDirective } from 'src/app/directves/drag.directive';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-upload-file-admin-display',
    imports: [CommonModule, ReactiveFormsModule, DragDirective, TranslateDirective, TranslatePipe],
    templateUrl: './upload-file-admin-display.component.html',
    styleUrls: ['./upload-file-admin-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileAdminDisplayComponent {
  @Input()
  question?: Question;
  @Input()
  isPreview?: boolean;
  @Input() viewAnswer = false;
  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ =toSignal(this.#questionnaireStore.isUser$.pipe(map(x => !x))) ;

  openFile() {
    if (this.question?.imageBase64) {
      const mimeTypeMatch = this.question.imageBase64.match(/^data:(.*);base64,/);
      const contentType = mimeTypeMatch ? mimeTypeMatch[1] : 'application/octet-stream';
      const base64Data = this.question.imageBase64.split(',')[1] || this.question.imageBase64;

      try {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: contentType });
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
      } catch (error) {
        console.error('Error opening file:', error);
      }
    }
  }
}
